<template>
  <div v-if="!isPrint">
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :field-name="fieldName"
      :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />

    <!-- 교육내용 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육내용</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>교육과정(필수)</div>
          <custom-option-selector :readonly="board.readonly" v-model="form.inputA_1" @select="changeTarget1" :options="diff" />
        </div>
        <div v-if="!!form.inputA_1 && 1 < diff[form.inputA_1.index].child.length" class="writeGridLineItem">
          <div>대상(작업명)</div>
          <custom-option-selector
            :readonly="board.readonly"
            v-model="form.inputA_2"
            :options="diff[form.inputA_1.index].child"
            placeholder="1. 고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)"
            @select="changeTarget2"
          />
        </div>
        <div>
          <div>교육제목(필수)</div>
          <ml-input v-model="form.inputA_3" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육일(필수)</div>
          <date-selector v-model="form.inputA_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>교육시간</div>
          <div class="time">
            <time-selector v-model="form.inputA_5" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="form.inputA_6" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>교육 실시자 성명</div>
          <ml-input v-model="form.inputA_9" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육 실시자 소속</div>
          <ml-input v-model="form.inputA_10" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육 실시자 직책</div>
          <ml-input v-model="form.inputA_11" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육장소</div>
          <ml-input v-model="form.inputA_7" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>비고</div>
          <ml-input v-model="form.비고" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
        <div>
          <div>교육 대상</div>
          <ml-input v-model="form.inputA_12" :readonly="board.readonly" placeholder="입력해 주세요" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>교육내용에 반영한 재해형태(필수)</div>
          <div>
            <disaster-class-selector :multiple="true" :readonly="board.readonly" :addData="['직접입력']" placeholder="입력해 주세요" v-model="form.inputA_8" />
            <div v-show="form.inputA_8.includes('직접입력')">
              <div>직접입력</div>
              <ml-input v-model="form.inputA_17" :readonly="board.readonly" placeholder="입력해 주세요" />
            </div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>교육방법</div>
          <div class="h-full flex" >
            <vs-checkbox v-model="form.교육방법" :readonly="board.readonly" vs-value="강의식">강의식</vs-checkbox>
            <vs-checkbox class="ml-4" v-model="form.교육방법" :readonly="board.readonly" vs-value="토의식">토의식</vs-checkbox>
            <vs-checkbox class="ml-4" v-model="form.교육방법" :readonly="board.readonly" vs-value="체험식">체험식</vs-checkbox>
            <vs-checkbox class="ml-4" v-model="form.교육방법" :readonly="board.readonly" vs-value="시청각">시청각</vs-checkbox>
          </div>
        </div>
      </div>
      <div>
        <table class="w-full mb-4" >
          <colgroup>
            <col width="16.66%" />
            <col width="16.66%" />
            <col width="16.66%" />
            <col width="16.66%" />
            <col width="33.36" />
          </colgroup>
          <tr class="border-bottom">
            <th class="py-3">구분</th>
            <th>계</th>
            <th>남</th>
            <th>여</th>
            <th>교육 미참석 사유</th>
          </tr>
          <tr class="border-bottom">
            <th>교육 대상자 수</th>
            <th><ml-input class="w-full" :value="getTotal대상자수" :readonly="true"/></th>
            <th><vs-input class="w-full" type="number" v-model="form.대상자수_남"/></th>
            <th><vs-input class="w-full" type="number" v-model="form.대상자수_여"/></th>
            <th><ml-input class="w-full" v-model="form.대상자수_미참석사유"/></th>
          </tr>
          <tr class="border-bottom">
            <th>교육 이수자 수</th>
            <th><ml-input class="w-full" :value="getTotal이수자수" :readonly="true"/></th>
            <th><vs-input class="w-full" type="number" v-model="form.이수자수_남"/></th>
            <th><vs-input class="w-full" type="number" v-model="form.이수자수_여"/></th>
            <th><ml-input class="w-full" v-model="form.이수자수_미참석사유"/></th>
          </tr>
          <tr class="border-bottom">
            <th>교육 미이수자 수</th>
            <th><ml-input class="w-full" :value="getTotal미이수자수" :readonly="true"/></th>
            <th><vs-input class="w-full" type="number" v-model="form.미이수자수_남"/></th>
            <th><vs-input class="w-full" type="number" v-model="form.미이수자수_여"/></th>
            <th><ml-input class="w-full" v-model="form.미이수자수_미참석사유"/></th>
          </tr>
        </table>

<!--        <div>-->
<!--          <div>교육 실시 인원</div>-->
<!--          <comma-input v-model="form.inputA_13" type="number" :readonly="board.readonly" placeholder="입력해 주세요" />-->
<!--          <p>명</p>-->
<!--        </div>-->
<!--        <div>-->
<!--          <div>교육 미실시 인원</div>-->
<!--          <comma-input v-model="form.inputA_14" type="number" :readonly="board.readonly" />-->
<!--          <p>명</p>-->
<!--        </div>-->


      </div>
    </div>

    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>교육내용</div>
        <ml-textarea rows="5" v-model="form.inputA_15" :readonly="true" placeholder="(예시) 고기압 장해의 인체에 미치는 영향에 관한 사항
○ 작업의 시간·작업 방법 및 절차에 관한 사항
○ 압기공법에 관한 기초지식 및 보호구 착용에 관한 사항
○ 이상 발생 시 응급조치에 관한 사항
○ 그 밖에 안전·보건관리에 필요한 사항"/>
      </div>
      <div class="writeGridLineItem">
        <div>특이사항</div>
        <ml-textarea rows="5" v-model="form.inputA_16" :readonly="board.readonly" />
      </div>
    </div>

    <!-- 참석자 명단 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="참석자 명단"
      :tableData="[
        { id: 'target', title: '부서명(직책)', type: 'text', placeholder: '' },
        { id: 'name', title: '성명', type: 'text', placeholder: '' },
        { id: 'sign', title: '서명', type: 'sign', placeholder: '' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.signatureList"
      class="mt-4"
    />

    <!-- 확인자 -->
    <div>
      <vs-row class="mt-8 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 결재란</h5>
        </vs-col>
      </vs-row>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      class="mb-8"
      v-model="form.photoList"
      :row-count="2"
      :grid-count="2"
      :is-print="isPrint"
      :readonly="board.readonly"
      :withDataType107="true"
      section-title="교육 사진"
      placeholder="신축현장 점검"
    />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
  <print v-else :form="form" />
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import Print from "./Print.vue";

import KPagination from "@/components/kPagination/kPagination";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import {valueDisasters} from "@/util/DisasterDataUtil";
import TableCustom from "@/components/TableCustom.vue";
import diffData from "./DiffData";
import SignField from "@/components/SignField.vue";
import {required} from "vuelidate/lib/validators";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import * as UiUtil from "@/util/UiUtil";

export default {
  components: {
    NameWithSignatureRow,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    CustomOptionSelector,
    FileUploadModule,
    DateSelector,
    DisasterClassSelector,
    TimeSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    TableCustom,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      inputA_1: { required },
      inputA_3: { required },
      inputA_4: { required },
      inputA_8: { required },
    },
  },
  data() {
    return {
      // =============== 이전 문서 불러오기 ===============
      isMounted: false,
      customButton: null,
      showPopup: false,
      disasterTypes: [{ text: "전체선택", value: "" }, ...valueDisasters()],
      searchTypes: [
        { value: "stdInfo.field_name", text: "현장명" },
        { value: "inputD_1", text: "재해일시" },
        { value: "inputD_3", text: "발생형태" },
        { value: "stdInfo.department", text: "소속명" },
        { value: "stdInfo.com_name", text: "부서명" },
        { value: "stdInfo.writer_name", text: "작성자" },
      ],
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },
      // 검색
      search: {
        date: "", // 작성일
        disasterType: "", // 발생형태
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      // =============== FORM ===============
      diff: diffData,
      form: {
        stdInfo: {},

        inputA_1: null,
        inputA_2: null,

        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: [],
        inputA_9: "",
        inputA_10: "",
        inputA_11: "",
        inputA_12: "",
        inputA_13: "",
        inputA_14: "",
        inputA_15: "",
        inputA_16: "",
        inputA_17: "",

        대상자수_남: "",
        대상자수_여: "",
        대상자수_미참석사유: "",
        이수자수_남: "",
        이수자수_여: "",
        이수자수_미참석사유: "",
        미이수자수_남: "",
        미이수자수_여: "",
        미이수자수_미참석사유: "",

        비고: "",
        교육방법: [],
        photoList: [],
        fileList: [],
        signatureList: [],
        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
        sign4: { name: "", sign: "" },
        disasters: "",
      },
    };
  },
  computed: {
    reportList() {
      if (this.$store.state.board.postListInfo.data) {
        return this.$store.state.board.postListInfo.data.map((item) => {
          return { id: item.id, ...this.getContent(item).body };
        });
      } else return [];
    },

    getDiff() {
      if (this.form.inputA_1) {
        if (this.diff[this.form.inputA_1.index].child.length === 1) {
          if (this.diff[this.form.inputA_1.index].child[0].value === "-") {
            return [];
          } else {
            return this.diff[this.form.inputA_1.index].child;
          }
        } else {
          return this.diff[this.form.inputA_1.index].child;
        }
      } else {
        return [];
      }
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    is내부종사자 () {
      return `${this.projectId}` === '2'
    },
    fieldName () {
      if (`${this.projectId}` === '3') {
        return '사업명(필수)'
      }
      return '사업장명(필수)'
    },

    getTotal대상자수 () {
      return Number(this.form.대상자수_남) + Number(this.form.대상자수_여)
    },

    getTotal이수자수 () {
      return Number(this.form.이수자수_남) + Number(this.form.이수자수_여)
    },

    getTotal미이수자수 () {
      return Number(this.form.미이수자수_남) + Number(this.form.미이수자수_여)
    },
  },
  watch: {
    "value": {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
        this.syncDiffSelection();
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        value.summary = {
          안전보건교육_현장명: [],
          안전보건교육_재해형태: [],
          안전보건교육_교육구분: [], //교육구분 -> 교육과정으로 변경됐으나, 기존에 저장된 데이터가 있으므로, 교육구분으로 남겨둠
          안전보건교육_현장별교육구분: [],
          안전보건교육_현장별재해형태: [],
        };

        value.summary["안전보건교육_현장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        if (this.form.inputA_1) {

          value.summary["안전보건교육_교육구분"].push({
            [this.form.inputA_1.value]: 1,
          });

          value.summary["안전보건교육_현장별교육구분"].push({
            [`${this.form.stdInfo.field_name}_${this.form.inputA_1.value}`]: 1,
          });
        }

        if (this.form.inputA_8 && this.form.inputA_8.length > 0) {

          for (const data of this.form.inputA_8) {

            value.summary["안전보건교육_재해형태"].push({
              [data]: 1,
            });

            value.summary["안전보건교육_현장별재해형태"].push({
              [`${this.form.stdInfo.field_name}_${data}`]: 1,
            });
          }
        }


        this.$emit("input", value);
      },
    },
    'form.inputA_8' : {
      immediate: true,
      deep: true,
      handler(value) {
        // 컬럼목록 및 검색용
        this.form.disasters = ""

        for (const data of this.form.inputA_8) {
          if (data !== "직접입력") {
            this.form.disasters += `${data} `
          } else {
            this.form.disasters += `${this.form.inputA_17} `
          }
        }
      }
    },
  },
  created () {
    if (this.value) {
      const keys = Object.keys(this.value);
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key];
        }
      }
    }
    this.syncDiffSelection();
  },
  methods: {
    // ======================= FORM =======================
    // 저장된 교육구분/대상(작업명)은 목록 index 기준으로 복원되므로,
    // 목록이 개정되어도 key(우선) 또는 이름(value) 기준으로 index를 다시 맞춘다
    syncDiffSelection() {
      const savedType = this.form.inputA_1;
      if (!savedType || (!savedType.key && !savedType.value)) return;
      let typeIndex = savedType.key ? this.diff.findIndex((item) => item.key === savedType.key) : -1;
      if (typeIndex < 0) typeIndex = this.diff.findIndex((item) => item.value === savedType.value);
      if (typeIndex > -1 && typeIndex !== savedType.index) {
        this.form.inputA_1 = { ...savedType, index: typeIndex };
      }
      const savedWork = this.form.inputA_2;
      if (typeIndex < 0 || !savedWork || (!savedWork.key && !savedWork.value)) return;
      const children = this.diff[typeIndex].child;
      let workIndex = savedWork.key ? children.findIndex((item) => item.key === savedWork.key) : -1;
      if (workIndex < 0) workIndex = children.findIndex((item) => item.value === savedWork.value);
      if (workIndex < 0) {
        // 항목 명칭이 개정된 경우 번호 접두사(예: "35.")로 폴백 매칭
        const prefix = (String(savedWork.value).match(/^\d+\./) || [])[0];
        if (prefix) workIndex = children.findIndex((item) => String(item.value).startsWith(prefix));
      }
      if (workIndex < 0) {
        // 한글 접두사(예: "가. ")·공백 제거 후 폴백 매칭 (구 안전보건관리책임자 교육 하위 항목 등)
        const normalize = (s) => String(s).replace(/^[가-힣]\.\s*/, "").replace(/\s+/g, "");
        // 명칭 자체가 개정된 항목의 구명칭 → 신명칭 별칭
        const legacyAlias = { "안전관리자및안전관리전문기관종사자": "안전관리책임자및안전관리전문기관종사자" };
        let key = normalize(savedWork.value);
        if (legacyAlias[key]) key = legacyAlias[key];
        workIndex = children.findIndex((item) => normalize(item.value) === key);
      }
      if (workIndex > -1 && workIndex !== savedWork.index) {
        this.form.inputA_2 = { ...savedWork, index: workIndex };
      }
    },
    changeTarget1(selected) {
      // v-model(form.inputA_1) 갱신보다 select 이벤트가 먼저 도착할 수 있으므로, 전달된 선택값을 직접 사용한다
      const target = selected || this.form.inputA_1;
      if (!target) return;
      if (1 === this.diff[target.index].child.length) {
        this.form.inputA_15 = this.diff[target.index].child[0].textarea;
      } else {
        this.form.inputA_2 = null;
        this.form.inputA_15 = "";
      }
    },
    changeTarget2(selected) {
      const work = selected || this.form.inputA_2;
      if (!!this.form.inputA_1 && !!work) this.form.inputA_15 = this.diff[this.form.inputA_1.index].child[work.index].textarea;
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.inputA_1.required) {
          UiUtil.alertDialog("교육과정을 반드시 입력해야 합니다");
        } else if (!this.$v.form.inputA_3.required) {
          UiUtil.alertDialog("교육제목을 반드시 입력해야 합니다");
        } else if (!this.$v.form.inputA_4.required) {
          UiUtil.alertDialog("교육일을 반드시 입력해야 합니다");
        } else if (!this.$v.form.inputA_8.required) {
          UiUtil.alertDialog("재해형태를 반드시 입력해야 합니다");
        }

        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;

  border-top: 1px solid #cdcdcd;
}
th,
td {
  padding: 0.5rem;
  margin: 0px;
  font-size: 1rem;
  border-bottom: 1px solid #cdcdcd;
}

th { text-align: center; }

</style>
